import BaseMygocuApiService from './BaseMygocuApiService';

const HOME_API_VERSION = 'v1';
const HOME_API_BASEPATH_URL = HOME_API_VERSION + '/grupos';

class ReservasApiService {
  async getProximasExperiencias() {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL);
  }

  async getGrupoByInvitacionGrupo(invitacionGrupoId) {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/grupoCerrado/' + invitacionGrupoId));
  }

  async getGrupo(grupoId, draft = false) {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/' + grupoId + '?draft=' + draft));
  }

  async getGrupoByCodigo(codigo, codigoPrevisualizacion = null) {
    const params = {};
    if (codigoPrevisualizacion) params.codigoPrevisualizacion = codigoPrevisualizacion;
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/' + codigo), params);
  }

  async getReservaDetalleUsuario(reservaId, email) {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat(`/${reservaId}/detalle/${email}`));
  }

  async doModificarServiciosReservasGrupo(grupoId, modificarReservaBody) {
    return await BaseMygocuApiService.post(HOME_API_BASEPATH_URL.concat(`/${grupoId}/servicios`), modificarReservaBody);
  }

  async doForzarPlazasLibres(grupoId) {
    return await BaseMygocuApiService.post(HOME_API_BASEPATH_URL.concat(`/${grupoId}/forzarPlazasLibres`));
  }

  async doEnviarCodigoGrupo(grupoId, info) {
    return await BaseMygocuApiService.post(HOME_API_BASEPATH_URL.concat(`/${grupoId}/enviarCodigo`), info);
  }

  async doCancelarReservasGrupo(grupoId, listaReservasCancelar, motivoCancelacionId, explicacionCancelacion) {
    return await BaseMygocuApiService.post(HOME_API_BASEPATH_URL.concat(`/${grupoId}/reservas/cancelar`), {
      reservasId: listaReservasCancelar,
      motivoCancelacionId,
      explicacionCancelacion,
    });
  }

  async doRecuperarReservasGrupo(grupoId, listaReservasRecuperar) {
    return await BaseMygocuApiService.post(HOME_API_BASEPATH_URL.concat(`/${grupoId}/reservas/recuperar`), {
      reservasId: listaReservasRecuperar,
    });
  }

  async getBusesGrupo(grupoId) {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat(`/${grupoId}/buses`));
  }

  async getBonoAdjunto(grupoId, reservaId) {
    return await BaseMygocuApiService.get(
      HOME_API_BASEPATH_URL.concat(`/${grupoId}/reservas/${reservaId}/bonoAdjunto`)
    );
  }

  async getMotivosCancelacion() {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/motivosCancelacion'));
  }

  async realizarCheckIn(reservaId, grupoId, reservaForm) {
    return await BaseMygocuApiService.post(
      HOME_API_BASEPATH_URL.concat(`/${grupoId}/reservas/${reservaId}/checkIn`),
      reservaForm
    );
  }

  async getServicioToValidar(grupoId, reservaId, codigoValidacion) {
    return await BaseMygocuApiService.get(
      HOME_API_BASEPATH_URL.concat(`/${grupoId}/reservas/${reservaId}/servicios/${codigoValidacion}`)
    );
  }

  async doValidarServicio(grupoId, reservaId, codigoValidacion) {
    return await BaseMygocuApiService.post(
      HOME_API_BASEPATH_URL.concat(`/${grupoId}/reservas/${reservaId}/servicios/${codigoValidacion}/validar`)
    );
  }

  async getFormularioInscripcion(grupoId, hash = null) {
    return await BaseMygocuApiService.get(HOME_API_BASEPATH_URL.concat('/' + grupoId + '/formulariosInscripcion'), {
      infoHash: hash,
    });
  }

  async postFormularioCheckIn(grupoId, reservaId, formData) {
    return await BaseMygocuApiService.post(
      HOME_API_BASEPATH_URL.concat(`/${grupoId}/reservas/${reservaId}/checkIn`),
      formData,
      {},
      { 'Content-Type': 'multipart/form-data' }
    );
  }

  async postFormularioDatosPersonales(grupoId, reservaId, datosPersonalesForm) {
    return await BaseMygocuApiService.post(
      HOME_API_BASEPATH_URL.concat(`/${grupoId}/reservas/${reservaId}/datosPersonales`),
      datosPersonalesForm
    );
  }

  async postFormularioPreguntas(grupoId, reservaId, formDataPreguntas) {
    return await BaseMygocuApiService.post(
      HOME_API_BASEPATH_URL.concat(`/${grupoId}/reservas/${reservaId}/preguntas`),
      formDataPreguntas
    );
  }

  async doCrearSuperGrupo(grupoId, infoSuperGrupo) {
    return await BaseMygocuApiService.post(HOME_API_BASEPATH_URL.concat(`/${grupoId}/supergrupo`), infoSuperGrupo);
  }

  async doUnirseSuperGrupo(grupoId, infoSuperGrupo) {
    return await BaseMygocuApiService.post(HOME_API_BASEPATH_URL.concat(`/${grupoId}/supergrupo/unir`), infoSuperGrupo);
  }

  async doCompartirSuperGrupo(grupoId, info) {
    return await BaseMygocuApiService.post(HOME_API_BASEPATH_URL.concat(`/${grupoId}/supergrupo/enviarCodigo`), info);
  }

  async doSalirSuperGrupo(grupoId) {
    return await BaseMygocuApiService.post(HOME_API_BASEPATH_URL.concat(`/${grupoId}/supergrupo/salir`));
  }

  async doExpulsarGrupoSuperGrupo(grupoId, grupoAExpulsar) {
    return await BaseMygocuApiService.post(HOME_API_BASEPATH_URL.concat(`/${grupoId}/supergrupo/expulsar`), {
      grupo: grupoAExpulsar,
    });
  }

  async doEliminarSuperGrupo(grupoId) {
    return await BaseMygocuApiService.delete(HOME_API_BASEPATH_URL.concat(`/${grupoId}/supergrupo/eliminar`));
  }

  async getSupergrupo(grupoId, codigo) {
    const response = await BaseMygocuApiService.get(`${HOME_API_BASEPATH_URL}/${grupoId}/supergrupo`, {
      codigo,
    });
    return response;
  }

  async getReciboPago(grupoId, solicitudCobroId, executeIfPossible = false) {
    const reciboPeticionDTO = {
      executeIfPossible,
    };
    return await BaseMygocuApiService.post(
      HOME_API_BASEPATH_URL.concat(`/${grupoId}/solicitudCobro/${solicitudCobroId}/recibo`),
      reciboPeticionDTO
    );
  }

  async getReciboResumen(grupoId, grupoReservasId, executeIfPossible = false) {
    const reciboPeticionDTO = {
      executeIfPossible,
    };
    return await BaseMygocuApiService.post(HOME_API_BASEPATH_URL.concat(`/${grupoId}/recibo`), reciboPeticionDTO);
  }
}

export default new ReservasApiService();
